import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import BackgroundImage from "../../assets/images/hide.jpg";

const zoomInOut = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.08); }
    100% { transform: scale(1); }
`;

const HeroSection = styled.header`
  position: relative;
  height: 35vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: url(${BackgroundImage}) center/cover no-repeat;
    animation: ${zoomInOut} 12s infinite;
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 3;
  }
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-size: 2.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  margin-top: 10px;
`;

const Section = styled.section`
  padding: 70px 0;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  height: 100%;
`;

const Heading = styled.h2`
  color: #0d6efd;
  font-weight: 700;
  margin-bottom: 20px;
`;

const Step = styled.div`
  display: flex;
  margin-bottom: 20px;

  .number {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #0d6efd;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-right: 15px;
    flex-shrink: 0;
  }

  h5 {
    margin-bottom: 5px;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #666;
  }
`;

const ContactBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0d6efd;
  padding: 20px;
  border-radius: 8px;
  margin-top: 25px;

  p {
    margin-bottom: 8px;
  }
`;

export default function Grievances() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const navigateMenu = () => {};

  return (
    <>
      <Header navigateMenu={navigateMenu} />

      <HeroSection>
        <div className="container text-center">
          <HeroTitle>Grievance Redressal</HeroTitle>
          <HeroSubtitle>
            We are committed to resolving your concerns quickly, transparently,
            and fairly.
          </HeroSubtitle>
        </div>
      </HeroSection>

      <Section>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <Card>
                <Heading>Our Commitment</Heading>

                <p>
                  At <strong>Finlab.One</strong>, customer satisfaction is our
                  highest priority. If you have any complaint, feedback, or
                  grievance regarding our services, we encourage you to reach
                  out to us.
                </p>

                <p>
                  Every grievance is acknowledged, reviewed, and resolved within
                  the defined turnaround time while maintaining complete
                  transparency.
                </p>

                <ContactBox>
                  <h5>Grievance Officer</h5>

                  <p>
                    <strong>Name:</strong> Vishal Parashar
                  </p>

                  <p>
                    <strong>Email:</strong> vishal.parashar@finlab.one
                  </p>

                  <p>
                    <strong>Phone:</strong> +91-9810019846
                  </p>

                  <p>
                    <strong>Working Hours:</strong> Monday – Friday (10:00 AM –
                    6:00 PM)
                  </p>
                  <p>
                    <strong>RBI Sachet Portal:</strong>{" "}
                    <a
                      href="https://sachet.rbi.org.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://sachet.rbi.org.in/
                    </a>
                  </p>
                </ContactBox>
              </Card>
            </div>

            <div className="col-lg-6">
              <Card>
                <Heading>Complaint Resolution Process</Heading>

                <Step>
                  <div className="number">1</div>

                  <div>
                    <h5>Submit Your Complaint</h5>

                    <p>
                      Share your grievance through email with all relevant
                      details.
                    </p>
                  </div>
                </Step>

                <Step>
                  <div className="number">2</div>

                  <div>
                    <h5>Acknowledgement</h5>

                    <p>
                      Your complaint will be acknowledged within 24-48 business
                      hours.
                    </p>
                  </div>
                </Step>

                <Step>
                  <div className="number">3</div>

                  <div>
                    <h5>Investigation</h5>

                    <p>
                      Our team reviews the issue and coordinates with relevant
                      departments.
                    </p>
                  </div>
                </Step>

                <Step>
                  <div className="number">4</div>

                  <div>
                    <h5>Resolution</h5>

                    <p>
                      We aim to resolve all genuine grievances within 7 working
                      days.
                    </p>
                  </div>
                </Step>
              </Card>
            </div>
          </div>
        </div>
      </Section>

      <Footer className="footer_section custom_footer_style" />
    </>
  );
}
